<template>
  <div class="card card-certificate">
    <!--<img class="card-img-top"  alt="Card image cap">-->
    <div class="card-body">
      <div class="row">
        <div class="col-4 card-name">Nombre</div>
        <div class="col-8 card-value">{{ user.nombre }}</div>
        <div class="col-4 card-name">Cargo</div>
        <div class="col-8 card-value">{{ user.cargo || '-' }}</div>
        <div class="col-4 card-name">Departamento</div>
        <div class="col-8 card-value">{{ user.departamento || '-' }}</div>
        <div class="col-4 card-name">Empresa</div>
        <div class="col-8 card-value">{{ company.razonSocial || '-' }}</div>

        <div class="col-4 card-name">Fecha Creación</div>
        <div class="col-8 card-value">{{ certificate.fechaCreacion || '-' }}</div>

        <div class="col-4 card-name">Fecha Vencimiento</div>
        <div class="col-8 card-value">{{ certificate.fechaCaducidad || '-' }}</div>

        <div class="col-4 card-name">Estado</div>
        <div class="col-8 card-value" v-if="certStatus.CREATE == certificate.estado">
          Creado Pendiente de activación
        </div>
        <div class="col-8 card-value" v-else-if="certStatus.ACTIVE == certificate.estado">
          Activo
        </div>
        <div class="col-8 card-value" v-else>
          No disponible
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { certStatus } from '@/febos/global/usuario/components/sign/simple/febos/constants';

export default {
  components: {},
  data() {
    return { certStatus };
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    company: {
      type: Object,
      required: true
    },
    certificate: {
      type: Object,
      required: true
    }
  }
};
</script>
<style>
.card-certificate {
  background-color: rgba(128, 128, 128, 0.15);
}
</style>
